import { render } from "./Quotations6.vue?vue&type=template&id=716f1e60"
import script from "./Quotations6.vue?vue&type=script&lang=js"
export * from "./Quotations6.vue?vue&type=script&lang=js"
script.render = render

export default script